'use strict';

module.exports = [require('./clone'), require('./isInteger'), require('./isNegative'), require('./isNumeric'), require('./isPositive'), require('./isPrime'), require('./isZero'), require('./isNaN'), require('./typeof')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/function/utils/index.js
// module id = XA7r
// module chunks = 0